<script>
    import {getNextInputId} from '../../helper/UIHelper'; 

    export let model;
    export let label;
    export let scheme;

    let localModel = model;
    let className = "";

    const checkForHttp = scheme == 'https://' || 'http://';
    export {className as class};

    let uid = getNextInputId();

    function onChange(){
    /*Special case -> if scheme is https:// also check for http:// */
    if(checkForHttp){
        if(localModel.startsWith('https://')){
            localModel = localModel.replace('https://', ''); 
            scheme = 'https://';
        }
        else if (localModel.startsWith('http://')){
            localModel = localModel.replace('http://', ''); 
            scheme = 'http://';
        }
    }
    else if(localModel.startsWith(scheme))
        localModel = localModel.replace(scheme, ''); 
    
    model = scheme + localModel;

    }

    $: localModel && onChange();
</script>

<div class="{className}">
  <label for="{uid}" class="block text-sm font-medium leading-5 text-gray-700">{label}</label>
    <div class="mt-1 rounded-md shadow-sm flex">
        <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
            {scheme}
        </span>
      <input bind:value={localModel} id="{uid}" type="text" on:blur class="flex-1 form-input block w-full rounded-none rounded-r-md transition duration-150 ease-in-out sm:text-sm sm:leading-5 text-main" />
    </div>
</div>
